import { useMemo } from 'react';
import { attachProgress } from '../logic/scheduleViewModel';
import { useActivityTasksSubscriptionQuery } from '../store/activityTasksApiSlice';
import { useProjectedTasks } from './useProjectedTasks';
import type { ScheduleTask } from '../types/ScheduleTask';

type UseParticipationScheduleParams = {
  userId: string;
  participationId: string;
};

// The schedule view-model for home and calendar: the PROSE-computed projected
// tasks joined with the participation's task documents to add per-task progress.
// The task-document subscription is the only Firestore listener here.
export const useParticipationSchedule = ({
  userId,
  participationId,
}: UseParticipationScheduleParams): {
  tasks: ScheduleTask[];
  isLoading: boolean;
  isRefreshing: boolean;
} => {
  const {
    tasks: projectedTasks,
    isLoading: isScheduleLoading,
    isRefreshing,
  } = useProjectedTasks();
  const { data: tasksData } = useActivityTasksSubscriptionQuery({
    userId,
    participationId,
  });

  const tasks = useMemo(
    () => attachProgress(projectedTasks, tasksData?.tasks ?? []),
    [projectedTasks, tasksData?.tasks]
  );

  const isLoading = isScheduleLoading || !tasksData?.isSnapshotReceived;
  return { tasks, isLoading, isRefreshing };
};
